import apiClient from '../../../Services/api-client.service';

class SimulationService {
  async createSession(dto: { interviewSessionId: string; roundId: string }) {
    const response = await apiClient.post('/simulation/sessions', dto);
    return response.data;
  }

  async getSessionStatus(sessionId: string) {
    const response = await apiClient.get(
      `/simulation/sessions/${sessionId}/status`,
    );
    return response.data;
  }

  async getSession(sessionId: string) {
    const response = await apiClient.get(`/simulation/sessions/${sessionId}`);
    return response.data;
  }

  async startSession(sessionId: string) {
    const response = await apiClient.post(
      `/simulation/sessions/${sessionId}/start`,
    );
    return response.data;
  }
}

export const simulationService = new SimulationService();
